import React from 'react';
import {
  Avatar,
  Card,
  CardActions,
  CardContent,
  IconButton,
  Typography,
  CardHeader,
  Box,
} from '@mui/material';
import Moment from 'react-moment';
import ReactPlayer from 'react-player';

interface amySaysProps {
  amySays;
}

const withProtocol = (url: string): string =>
  /^https?:\/\//i.test(url) ? url : `https://${url}`;

const isVideoUrl = (url: string): boolean => {
  if (/\/api\/images\/videos\//i.test(url)) return true;
  if (/\.(mp4|webm|ogg|mov)(\?.*)?$/i.test(url)) return true;
  return ReactPlayer.canPlay(url);
};

const AmySaysCard = ({ amySays }: amySaysProps) => {
  return (
    <Card
      sx={{
        minWidth: '100%',
        background: 'linear-gradient(45deg, #674BFF 30%, #9b78b6 90%)',
        boxShadow: 'none',
        borderRadius: '20px',
        objectFit: 'contain',
        objectPosition: 'bottom',
      }}
    >
      <CardHeader
        avatar={
          <Avatar src={'content/images/logos/reachamy.webp'}>
            AMY
          </Avatar>
        }
        title="AMY says"
        titleTypographyProps={{ sx: { color: '#ffff' } }}
      />
      <CardContent>
        {amySays?.title && (
          <Typography variant="body2" sx={{ color: '#FFF', fontWeight: 600 }}>
            {amySays?.title}
          </Typography>
        )}
        <Typography
          variant="body2"
          sx={{ color: '#FFF', whiteSpace: 'pre-wrap' }}
        >
          {amySays?.message}
        </Typography>

        {amySays?.mediaUrl && (
          <Box sx={{ mt: 1.5 }}>
            {isVideoUrl(amySays.mediaUrl) ? (
              <Box sx={{ position: 'relative', paddingTop: '56.25%', borderRadius: '12px', overflow: 'hidden', bgcolor: '#000' }}>
                <ReactPlayer
                  url={amySays.mediaUrl}
                  controls
                  width="100%"
                  height="100%"
                  style={{ position: 'absolute', top: 0, left: 0 }}
                  config={{
                    file: {
                      forceVideo: true,
                      attributes: {
                        style: { width: '100%', height: '100%' },
                      },
                    },
                  }}
                />
              </Box>
            ) : (
              <a
                href={withProtocol(amySays.mediaUrl)}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: '#DDD7FF',
                  fontSize: '13px',
                  wordBreak: 'break-all',
                  display: 'inline-block',
                  marginTop: '4px',
                }}
              >
                {amySays.mediaUrl}
              </a>
            )}
          </Box>
        )}
      </CardContent>
      <CardActions sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <IconButton sx={{ color: '#FFF', fontSize: '12px' }}>AM with You</IconButton>
        {!amySays?.title && (
          <IconButton sx={{ color: '#FFF', fontSize: '12px' }}>
            <Moment fromNow>{amySays?.createdAt}</Moment>
          </IconButton>
        )}
      </CardActions>
    </Card>
  );
};

export default AmySaysCard;
